import { createStructuredSelector, createSelector } from 'reselect'
import {
  isMobileSelector,
  loadingSelector,
  usedFreeTrialSelector,
  recaptchaSelector,
  hasSubscriptionSelector
} from 'reduxModules/app/selectors'
import { isLifetimeSelector } from 'reduxModules/auth/selectors'

export const subscriptionPlansSelector = (state) => state.subscriptions.plans

export const subscriptionPlansLanguageSelector = (state) =>
  state.subscriptions.subscriptionPlansLanguage

export const lifetimeEnabledSelector = (state) =>
  Boolean(state.subscriptions.subscriptionPlansLanguage?.lifetimeEnabled)

export const subscriptionBannerIsReadySelector = (state) =>
  state.subscriptions.bannerSubscriptionIsReady

export const globalPromoSelector = (state) => state.app.globalPromo

export const isGlobalPromoEnabledSelector = (state) =>
  Boolean(
    state.app.globalPromo.codename && state.app.globalPromo.codename.length > 0
  )

export const subscriptionPlanSelectors = createSelector(
  [
    isMobileSelector,
    usedFreeTrialSelector,
    globalPromoSelector,
    isGlobalPromoEnabledSelector,
    subscriptionPlansLanguageSelector,
    lifetimeEnabledSelector
  ],
  (
    isMobile,
    usedFreeTrial,
    globalPromo,
    isGlobalPromoEnabled,
    subscriptionPlansLanguage,
    lifetimeEnabled
  ) => ({
    isMobile,
    usedFreeTrial,
    globalPromo,
    isGlobalPromoEnabled,
    subscriptionPlansLanguage,
    lifetimeEnabled
  })
)

export const giftSubscriptionSelector = (state) => ({
  ...state.subscriptions.giftSubscriptionDetail,
  recaptcha: recaptchaSelector(state)
})

export default createStructuredSelector({
  isMobile: isMobileSelector,
  loading: loadingSelector,
  isGlobalPromoEnabled: isGlobalPromoEnabledSelector,
  lifetimeEnabled: lifetimeEnabledSelector,
  isLifetime: isLifetimeSelector
})

export const subscriptionBannerSelector = createStructuredSelector({
  subscriptionPlansLanguage: subscriptionPlansLanguageSelector,
  bannerSubscriptionIsReady: subscriptionBannerIsReadySelector,
  hasSubscription: hasSubscriptionSelector
})
